module.exports = __webpack_public_path__ + "img/mille_branding.438389a7.jpg";